import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Loader.css';

const cx = classnames.bind(styles);

function Loader({className, variant}) {
    const classes = cx({
        root: true,
        [className]: Boolean(className),
        [variant]: Boolean(variant)
    });

    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 22 22'
            className={classes}
        >
            <g stroke='#FFF' strokeWidth='2' strokeLinecap='round'>
                <path stroke='#ffffffE0' d='M11 1v4' />
                <path stroke='#ffffffC0' d='M3.93 3.93l2.83 2.83' />
                <path stroke='#ffffffA0' d='M1 11h4' />
                <path stroke='#ffffff80' d='M3.93 18.07l2.83-2.83' />
                <path stroke='#ffffff60' d='M11 17v4' />
                <path stroke='#ffffff40' d='M15.24 15.24l2.83 2.83' />
                <path stroke='#ffffff20' d='M17 11h4' />
                <path stroke='#ffffff00' d='M15.24 6.76l2.83-2.83' />
            </g>
        </svg>
    );
};

Loader.propTypes = {
    className: PropTypes.string,
    variant: PropTypes.string
};

Loader.defaultProps = {
    className: '',
    variant: ''
};

export {
    Loader
};
